module.exports = __webpack_public_path__ + "static/media/computer.e01082af.png";